import { createSelector } from '@reduxjs/toolkit';

import { KnownDevice, UnknownDevice } from '@playq/octopus2-devices';

import { RootState } from '/store/RootState';

export const baseSelectors = {
  devices: (state: RootState) => state.devices.devices,
  deviceState: (state: RootState) => state.devices,
  streamEvents: (state: RootState) => state.devices.streamEvents,
};

export const selectSubscriptionDevice = createSelector(baseSelectors.devices, (device) => {
  if (device.length !== 0) {
    return {
      name: 'name' in device[0] ? new KnownDevice(device[0]).name : new UnknownDevice(device[0]).alias.installationId,
      device: 'name' in device[0] ? new KnownDevice(device[0]) : new UnknownDevice(device[0]),
    };
  }
});
